<template>
    <b-modal size="md" button-size="sm" v-model="showModal" :title="prefix + title" hide-footer @hidden="cancelar">
        <b-card bg-variant="light">
            <b-form @submit.prevent="save">
                <b-col>
                    <lg-form-input id="searchText" label="Complemento:" v-model="complemento" :disabled="isVisualizacao" />
                </b-col>
            </b-form>

            <div class="d-flex justify-content-center mt-3">
                <b-button id="confirmarSalvar" @click="save" variant="success" style="height: 30px" pill
                    size="sm">
                    <div>
                        <b-icon icon="check-circle" />
                    </div>
                </b-button>
                <b-button id="cancelarSalvar" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm"
                    variant="danger">
                    <div>
                        <b-icon icon="x-circle" />
                    </div>
                </b-button>
            </div>

        </b-card>

    </b-modal>
</template>

<script>
import { ListResourceMixin } from "@/core/mixins/resource";
import ResourceService from "@/core/api/ResourceService";
import ConfirmMixin from "@/core/mixins/confirm";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";

export default {
    components: {
        LgFormInput,
    },
    props: {
        id: Number,
        isVisualizacao: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Complemento"
        }
    },
    data() {
        return {
            showModal: true,
            complemento: '',
        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    async beforeMount() {
        this.$service = new ResourceService(`/api/itembempermanente`);
        var {data}  = await this.$service.get("complemento/" + this.id );

        this.complemento = data.complemento;
    }, 
    methods: {
        async save() {


            try {
                this.busy = true;

                await this.$service.put("complemento/" + this.id, {complemento: this.complemento});

            }
            finally {

                this.cancelar();
            }

        },
        cancelar() {
            this.$emit("close");
        },
    },
};
</script>